import React from 'react';

import { IWishlistingEventData } from '@/services/analytics/listings/types';
import { TAutoRentalTile } from '@/utility/mapAutoSearchResultToTile';
import { ISearchResultTile } from '@/utility/mapSearchResultToTile';

import { ListingTileFavoriteToggle } from './ListingTileFavoriteToggle';
import { ListingTileRebook } from './ListingTileRebook';
import { ListingTileTag } from './ListingTileTag';

type TListingTileMediaActionsProps = {
  listingTile: ISearchResultTile | TAutoRentalTile;
  hideFavoriteCount?: boolean;
  wishlistingEventData?: IWishlistingEventData;
  showFavoriteToggleAnimation?: boolean;
  hideTagsOnSmallScreen?: boolean;
  showNewListingTag?: boolean;
  showLimitedOfferTag?: boolean;
  showGuestFavoriteTag?: boolean;
  showSuperhostBadge?: boolean;
  showBeginnerFriendlyBadge?: boolean;
  isFeatured?: boolean;
};

export const ListingTileMediaActions = ({
  listingTile,
  hideFavoriteCount,
  wishlistingEventData,
  showFavoriteToggleAnimation,
  hideTagsOnSmallScreen,
  showNewListingTag,
  showLimitedOfferTag,
  showGuestFavoriteTag,
  showSuperhostBadge,
  showBeginnerFriendlyBadge,
  isFeatured,
}: TListingTileMediaActionsProps) => {
  return (
    <>
      <div className="absolute top-0 left-0 flex justify-between w-full p-5 gap-2">
        <ListingTileTag
          listingTile={listingTile}
          hideTagsOnSmallScreen={hideTagsOnSmallScreen}
          showNewListingTag={showNewListingTag}
          showLimitedOfferTag={showLimitedOfferTag}
          showGuestFavoriteTag={showGuestFavoriteTag}
          showSuperhostBadge={showSuperhostBadge}
          showBeginnerFriendlyBadge={showBeginnerFriendlyBadge}
          isFeatured={isFeatured}
        />

        <div className="ml-auto">
          <ListingTileFavoriteToggle
            listingTile={listingTile}
            isLoading={listingTile.loading}
            isFavorite={listingTile.isFavorite}
            favoriteCount={listingTile.favoriteCount}
            hideFavoriteCount={hideFavoriteCount}
            wishlistingEventData={wishlistingEventData}
            showFavoriteToggleAnimation={showFavoriteToggleAnimation}
          />
        </div>
      </div>

      <div className="absolute bottom-0 right-0 px-5 py-4">
        <ListingTileRebook listingTile={listingTile} />
      </div>
    </>
  );
};
